module.exports = __webpack_public_path__ + "img/icone-white.3554d0a5.webp";